export default __webpack_public_path__ + "static/1-c597475a78d8f5f42df31042207325f9.jpeg";